import { Navigate } from 'react-router-dom';

import { PATHS } from '@/config/paths';
import { useAppSelector } from '@/hooks/useAppSelector';

interface Props {
  children: React.ReactNode;
}

export function PublicRoute({ children }: Props) {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={PATHS.DASHBOARD} replace />;
  }

  return <>{children}</>;
}
